import React from "react";
import "./App.css";

export default function Footer() {
  return (
    <footer className="Footer">
      <a
        href="https://github.com/Elisawirsiy/react-weather-app"
        className="profile-link"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>{" "}
      by Elizabeth Wirsiy
    </footer>
  );
}
